export const guardTone = (guardPass) => {
  if (guardPass === true) return 'pass';
  if (guardPass === false) return 'fail';
  return 'pending';
};

export const scopeLabel = (row = {}) => {
  if (row.scopeKind === 'company') return 'Company';
  if (row.scopeKind === 'lob') return String(row.lob || row.label || 'LOB');
  const entity = row.planningEntity || row.entity || '';
  const glGroup = row.glGroup || '';
  if (entity && glGroup) return `${entity} · ${glGroup}`;
  return entity || glGroup || 'Line';
};

const narrativeRowsFromBoard = (board = {}) => {
  const rows = [];
  if (board.company) {
    rows.push({
      scopeKind: 'company',
      variance: board.company.variance,
      narrative: board.company.narrative ?? null,
      key: 'company',
    });
  }
  (board.lobs || []).forEach((lob, index) => {
    rows.push({
      scopeKind: 'lob',
      lob: lob.lob,
      variance: lob.variance,
      narrative: lob.narrative ?? null,
      key: `lob-${lob.lob || index}`,
    });
  });
  const lines = [...(board.lines || [])].sort(
    (a, b) => Math.abs(Number(b.variance) || 0) - Math.abs(Number(a.variance) || 0)
  );
  lines.forEach((line, index) => {
    rows.push({
      scopeKind: 'line',
      planningEntity: line.planningEntity,
      glGroup: line.glGroup,
      variance: line.variance,
      narrative: line.narrative ?? null,
      key: `line-${line.planningEntity || 'entity'}-${line.glGroup || index}`,
    });
  });
  return rows;
};

export const guardSummary = (board = {}) => {
  const rows = narrativeRowsFromBoard(board);
  const withNarrative = rows.filter((row) => row.narrative != null);
  const pass = withNarrative.filter((row) => row.narrative?.guardPass === true).length;
  return {
    n: withNarrative.length,
    pass,
    pending: withNarrative.length - pass,
  };
};

export const bridgeCoverage = (lines = []) => {
  const list = Array.isArray(lines) ? lines : [];
  const withBridge = list.filter((line) => {
    const citations = line?.narrative?.citations || {};
    const bridgeIds =
      citations.bridgeComponentIds || citations.bridge_component_ids ||
      citations.bridgeIds || citations.bridge_ids;
    return Array.isArray(bridgeIds) && bridgeIds.length > 0;
  }).length;
  return { n: withBridge, m: list.length };
};

export const buildNarrativeQaRows = (board = {}) => narrativeRowsFromBoard(board);

export const guardSummaryStrip = (board = {}, basis = 'budget') => {
  const { n, pass, pending } = guardSummary(board);
  return `${n} narratives · ${pass} guard pass · ${pending} pending/fail · basis ${basis}`;
};

export const bridgeCoverageLine = (lines = []) => {
  const { n, m } = bridgeCoverage(lines);
  return `Bridges computed for ${n} of ${m} lines`;
};
